import React, { Component } from 'react';
import ReplyBoxField from 'components/ReplyBoxField';
import SenderSelect from 'components/SenderSelect';
import PropTypes from 'prop-types';

class ReployBoxWithSenderField extends Component {
  static propTypes = {
    value: PropTypes.shape({
      message: PropTypes.oneOfType(PropTypes.string, PropTypes.obj),
      sender: PropTypes.number,
    }),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
    value: { message: null, sender: null },
  };

  handleMessageChange(message) {
    this.props.onChange(Object.assign({}, this.props.value, { message }));
  }

  handleSenderChange(sender) {
    this.props.onChange(Object.assign({}, this.props.value, { sender }));
  }

  render() {
    return (
      <div className="ReployBoxWithSenderField">
        <ReplyBoxField
          {...this.props}
          value={this.props.value.message}
          onChange={this.handleMessageChange.bind(this)}
        />
        <SenderSelect
          {...this.props}
          multi={false}
          value={this.props.value.sender}
          onChange={this.handleSenderChange.bind(this)}
        />
      </div>
    );
  }
}

export default ReployBoxWithSenderField;
